import { alertRequest, request } from "services/request";

const resource = "api/adminpanel";

const getLastNeuralNetworkTask = () => request(`${resource}/getLastNeuralNetworkTask`, { method: "GET" });

const startNeuralNetworkTraining = (params: {}) => alertRequest(`${resource}/startNeuralNetworkTraining`, params);

const cancelLastNeuralNetworkTask = () => alertRequest(`${resource}/cancelLastNeuralNetworkTask`, {});

export { getLastNeuralNetworkTask, startNeuralNetworkTraining, cancelLastNeuralNetworkTask };
